// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 76 ? "common" : chunkId) + "." + {"18":"2be964ff3447a7ad","76":"2f83c6ad21f93970","271":"7a31f490801a115d","473":"933767d10b0852c1","595":"943c41af8524ae1e","643":"24eed6a5e0862dee","654":"6563a22a260ff2ee","771":"64e95b3e65e9808a"}[chunkId] + ".js";
};